module.exports = __webpack_public_path__ + "img/invitations-header.71f1afa3.png";